export default function EikaMenuComponent(rootElement: HTMLElement) {
    if (typeof rootElement === 'undefined' || rootElement === null) {
        return;
    }
    const menuButton: HTMLButtonElement | null = document.querySelector('#toggleMenuButton');
    const menuContainer: HTMLElement | null = document.querySelector('.menu');
    const menuInner: HTMLElement | null = menuContainer?.querySelector('.menu__container') ?? null;
    const menuParentBtn: NodeListOf<HTMLButtonElement> | undefined = menuContainer?.querySelectorAll(
        '.menu__item-header .menu__item--container',
    );
    const menuOpenClass = 'menu--open';
    const tabbableElements = Array.from(
        menuContainer?.querySelectorAll('button,input,select,textarea,[href],[tabindex]:not([tabindex="-1"])') ?? [],
    );
    const overlayDiv: HTMLElement | null = document.querySelector('#nav-overlay');
    if (overlayDiv && menuContainer) {
        menuContainer.style.display = '';
        overlayDiv.style.display = '';
    }
    const menuIsVisible = () => {
        return document.body.classList.contains(menuOpenClass);
    };
    if (menuButton !== null && menuContainer !== null) {
        const closeOpenMenus = (currentTarget: HTMLLIElement) => {
            const openSubMenus = menuContainer.querySelectorAll('.menu__submenu--active');
            if (openSubMenus.length > 0) {
                openSubMenus.forEach((subel) => {
                    if (typeof currentTarget === 'undefined' || subel !== currentTarget) {
                        subel.classList.remove('menu__submenu--active');
                        subel.querySelector('button')?.setAttribute('aria-expanded', 'false');
                    }
                });
            }
        };

        const toggleSubMenus = (e: Event): void => {
            const expandEl = (e.target as HTMLElement).closest('.menu__item-header') as HTMLLIElement;
            const btn = e.target as HTMLElement;
            const activeListItemClass = 'menu__submenu--active';
            if (expandEl !== null) {
                closeOpenMenus(expandEl);
                const isActive = expandEl.classList.toggle(activeListItemClass);
                btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
            }
            e.preventDefault();
        };

        const toggleMenu = (e: Event): void => {
            const btnLabel = menuButton.querySelector('.menu-label') as HTMLElement;
            if (btnLabel !== null) {
                if (!menuIsVisible()) {
                    document.body.classList.add(menuOpenClass);
                    menuButton.setAttribute('aria-expanded', 'true');
                    const ariaLabelClose = `${btnLabel.getAttribute('data-dictionary-close')!} ${btnLabel.getAttribute(
                        'data-dictionary-open',
                    )!}` as string;
                    menuButton.setAttribute('aria-label', ariaLabelClose);
                    btnLabel.innerText = btnLabel.getAttribute('data-dictionary-close')!;
                    menuContainer.removeAttribute('inert');
                } else {
                    document.body.classList.remove(menuOpenClass);
                    menuButton.setAttribute('aria-expanded', 'false');
                    const ariaLabelOpen = btnLabel.getAttribute('data-dictionary-open')! as string;
                    menuButton.setAttribute('aria-label', ariaLabelOpen);
                    btnLabel.innerText = ariaLabelOpen;
                    menuContainer.setAttribute('inert', 'true');
                }
                e.preventDefault();
            }
        };
        menuButton.addEventListener('click', toggleMenu);
        document.addEventListener('click', (e) => {
            const clickedElm = e.target as Node | null;
            if (!menuInner?.contains(clickedElm) && !menuButton.contains(clickedElm)) {
                if (menuIsVisible()) {
                    toggleMenu(e);
                }
            }
        });

        document.addEventListener('keydown', (e: KeyboardEvent) => {
            if (!menuIsVisible()) {
                return;
            }

            if (e.key === 'Tab' && !e.shiftKey) {
                const inFocus = document.activeElement;
                const lastMenuItem = tabbableElements[tabbableElements.length - 1];

                if (lastMenuItem === inFocus) {
                    menuButton.focus();
                    e.preventDefault();
                }
            }
            if (e.key === 'Escape' || e.keyCode === 27) {
                toggleMenu(e);
                e.preventDefault();
            }
        });

        menuParentBtn?.forEach((btn: HTMLButtonElement) => {
            btn.addEventListener('click', toggleSubMenus);
        });
    }
}
